<template>
    <div>
        <p class="text-small text-primary font-weight-medium mb-3">
            <v-icon class="me-2" color="secondary" size="20">icon-chart</v-icon>میزان رضایتمندی از کاربران سازمانی
        </p>
        <v-skeleton-loader v-if="skeleton" class="mx-auto" height="350" type="ossein"></v-skeleton-loader>
        <apexchart
            :options="chartOptions"
            :series="series"
            height="350"
            v-else
        ></apexchart>
    </div>
</template>
<script>
import fa from "apexcharts/dist/locales/fa.json";
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    props: {
    },
    data() {
        return {
            skeleton: true,
            series: [],
            chartOptions: {
                chart: {
                    locales: [fa],
                    defaultLocale: "fa",
                    stacked: true,
                    type: "bar",
                },
                plotOptions: {
                    bar: {
                        borderRadius: 2,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                grid: {
                    row: {
                        colors: ["#fff", "#f2f2f2"],
                    },
                },
                tooltip: {
                    style: {
                        fontFamily: "iransans",
                    },
                    y: {
                        title: {
                            formatter: () => "درصد رضایتمندی:",
                        },
                    },
                },
                xaxis: {
                    labels: {
                        rotate: -45,
                        style: {
                            fontFamily: "iransans",
                        },
                    },
                    categories: [],
                    tickPlacement: "on",
                },
                yaxis: {
                    labels: {
                        formatter: (value) => {
                            return value + "%";
                        },
                        style: {
                            fontFamily: "iransans",
                        },
                    },
                },
            },
        };
    },
    methods: {
        getReportSatisfactionEmployee(){
            this.$reportSatisfactionEmployee().then((res) => {
                if (res && res.status == "OK") {
                    this.series = []
                    this.chartOptions.xaxis.categories = []
                    this.series.push({
                        data: res.data.map((item) => Math.round(item.y)),
                    });
                    this.chartOptions.xaxis.categories.push(
                        ...res.data.map((item) => item.x)
                    );
                    this.skeleton = false;
                }
            });
        }
    },
    mounted() {
        this.getReportSatisfactionEmployee()
    },
};
</script>
